import './config_panel'
import './events'
import './general_pages'
import './management'
import './restricted_pages'
import './base'
